<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" />
        <action-button type="delete" @click="del(coursetypegroup.id)" v-if="$can('coursetypegroup-delete') && modal != true" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  name="coursetypegroup.name"
                  v-model="coursetypegroup.name"
                  class="required-field"
                  v-validate="'required|max:150'"
                  :label="$t('coursetypegroups.name')"
                  :error-messages="errors.collect('coursetypegroup.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="coursetypegroup.category"
                  v-model="coursetypegroup.category"
                  class="required-field"
                  v-validate="'required|max:150'"
                  :label="$t('coursetypegroups.category')"
                  :error-messages="errors.collect('coursetypegroup.category')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="coursetypegroup.type"
                  v-model="coursetypegroup.type"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_course_type_groups_type()"
                  :label="$t('coursetypegroups.type')"
                  :error-messages="errors.collect('coursetypegroup.type')"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="coursetypegroup.status"
                  v-model="coursetypegroup.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_course_type_groups_status()"
                  :label="$t('coursetypegroups.status')"
                  :error-messages="errors.collect('coursetypegroup.status')"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox
                  name="coursetypegroup.available_to_all"
                  v-model="coursetypegroup.available_to_all"
                  :label="$t('coursetypegroups.available_to_all')"
                  :error-messages="errors.collect('coursetypegroup.available_to_all')"
                  @change="availableToAllChange"
                >
                </v-checkbox>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox
                  name="coursetypegroup.coursetype_mandatory"
                  v-model="coursetypegroup.coursetype_mandatory"
                  :label="$t('coursetypegroups.coursetype_mandatory')"
                  :error-messages="errors.collect('coursetypegroup.coursetype_mandatory')"
                  :disabled="!Boolean(coursetypegroup.available_to_all)"
                >
                </v-checkbox>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "CourseTypesForm",

  props: ["id", "modal"],

  data() {
    return {
      page_title: "",
      predata: {},
      coursetypegroup: {},
      dictionary: {
        attributes: {
          "coursetypegroup.name": this.$t("coursetypegroups.name"),
          "coursetypegroup.category": this.$t("coursetypegroups.category"),
          "coursetypegroup.status": this.$t("coursetypegroups.status"),
          "coursetypegroup.type": this.$t("coursetypegroups.type"),
          "coursetypegroup.available_to_all": this.$t("coursetypegroups.available_to_all"),
          "coursetypegroup.coursetype_mandatory": this.$t("coursetypegroups.coursetype_mandatory")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.coursetypegroup, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    if (!this.id) {
      this.coursetypegroup = {
        status: this.$getDefaultDropdown(this.$dd_course_type_groups_status())
      }

      // JSON stringify and parse to remove variable reactiveness
      this.predata = JSON.parse(JSON.stringify(this.coursetypegroup))

      this.setPageTitle()
    } else {
      this.title = this.$t("coursetypegroups.update_title")

      axios
        .get(this.API_URL + "coursetypegroup/" + this.id)
        .then((res) => {
          this.coursetypegroup = res.data.data

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.coursetypegroup))

          this.setPageTitle()
        })
        .catch((err) => console.log(err))
    }
  },

  methods: {
    setPageTitle() {
      if (_.has(this.coursetypegroup, "id")) {
        this.page_title = this.$t("coursetypegroups.edit_coursetypegroup", {
          name: this.coursetypegroup.name
        })
      } else {
        this.page_title = this.$t("coursetypegroups.new_coursetypegroup")
      }
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.coursetypegroup.id) {
              // Create
              axios
                .post(this.API_URL + "coursetypegroup", {
                  name: this.coursetypegroup.name,
                  category: this.coursetypegroup.category,
                  status: this.coursetypegroup.status,
                  type: this.coursetypegroup.type,
                  available_to_all: this.coursetypegroup.available_to_all,
                  coursetype_mandatory: this.coursetypegroup.coursetype_mandatory
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.$awn.success(vm.$t("global.create_success"))

                      if (vm.modal) {
                        vm.$emit("return_modal_form", {
                          module: "coursetypegroup",
                          mode: "add",
                          data: res.data.data
                        })
                      } else {
                        vm.coursetypegroup = res.data.data
                        vm.predata = JSON.parse(JSON.stringify(vm.coursetypegroup))
                        vm.setPageTitle()
                        vm.$router.replace(this.BACKEND_URL + `/coursetypegroups/edit/${vm.coursetypegroup.id}`).catch(() => {})
                      }
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "coursetypegroup", {
                  id: this.coursetypegroup.id,
                  name: this.coursetypegroup.name,
                  category: this.coursetypegroup.category,
                  status: this.coursetypegroup.status,
                  type: this.coursetypegroup.type,
                  available_to_all: this.coursetypegroup.available_to_all,
                  coursetype_mandatory: this.coursetypegroup.coursetype_mandatory
                })
                .then((res) => {
                  vm.coursetypegroup = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.coursetypegroup))

                  vm.setPageTitle()
                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "coursetypegroup",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursetypegroup/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/coursetypegroups")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    availableToAllChange() {
      if (!this.coursetypegroup.available_to_all) {
        this.coursetypegroup.coursetype_mandatory = false
      }
    }
  }
}
</script>

<style scoped></style>
